var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"square-button",attrs:{"title":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('button-clicked')}}},[_c('md-button',{staticClass:"md-icon-button"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }